<template>
  <div>
    <div class="list-table__title">History</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="stamps"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(Edit)="stamps">
        <b-button
          pill
          variant="outline-secondary"
          @click="editHistory(stamps.item)"
        >
          Edit
        </b-button>
      </template>

      <template #cell(Delete)="stamps">
        <div>
          <font-awesome-icon
            @click="deleteStamp(stamps.item.attendanceId)"
            icon="trash-alt"
            class="trash-icon"
          />
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Stamp } from '@/store/clockIn/types';
import { Moment } from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StampHistories extends Vue {
  @Prop() stamps!: Stamp[]
  // props: {
  //   clockInLists: Array,
  // },

  private fields: any = [
    {
      key: 'date',
      label: 'Time',
      sortable: true,
      formatter: (date: Moment) => {
        // const h = value.substr(0, 2);
        // const m = value.substr(2, 2);
        // return `${h}：${m}`;
        return date.format('H:mm')
        // this.formatTime(value)
      },
    },
    {
      key: 'type',
      label: 'Clock-in/Waiting',
      sortable: true,
    },
    { key: 'Edit' },
    { key: 'Delete' },
  ]
  // data() {
  //   return {
  //     fields: [
  //       {
  //         key: 'time',
  //         label: 'Time',
  //         sortable: true,
  //         formatter: (value) => this.formatTime(value),
  //       },
  //       {
  //         key: 'type',
  //         label: 'Clock-in/Waiting',
  //         sortable: true,
  //       },
  //       { key: 'Edit' },
  //       { key: 'Delete' },
  //     ],
  //   };
  // },

  private editHistory(stamp: Stamp) {
    this.$emit('editHistory', stamp);
  }

  private deleteStamp(attendanceId: string) {
    this.$emit('deleteStamp', attendanceId);
  }

  // methods: {
  //   // formatTime(time) {
  //   //   const h = time.substr(0, 2);
  //   //   const m = time.substr(2, 2);
  //   //   return `${h}：${m}`;
  //   // },

  //   editHistory(clockInList) {
  //     this.$emit('editHistory', clockInList);
  //   },
  //   deleteHistory(attendanceId) {
  //     this.$emit('deleteHistory', attendanceId);
  //   },
  // },
}
</script>

<style scoped>
  .trash-icon {
    width: 15%;
    height: 15%;
  }
</style>
